import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import OurServices from "./sections/OurServices";
import FeaturedCaseStudies from "./sections/FeaturedCaseStudies";
import ResourceLibraryHighlights from "./sections/ResourceLibraryHighlights";
import Testimonials from "./sections/Testimonials";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <Hero />
      <OurServices />
      <FeaturedCaseStudies />
      <ResourceLibraryHighlights />
      <Testimonials />
      <Footer />
    </div>;
}